import React from "react";
import { Box } from "@mui/material";

const SectionHeader = ({ label, title, subtitle, maxWidth = "686px", sx = {} }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      ...sx,
    }}
  >
    {label && (
      <Box
        component="p"
        sx={{
          fontFamily: "Nunito, sans-serif",
          fontWeight: 700,
          fontSize: "18px",
          lineHeight: "18px",
          color: "#a9c74e",
          textAlign: "center",
          mb: "13px",
          m: 0,
          mb: "13px",
        }}
      >
        {label}
      </Box>
    )}
    {title && (
      <Box
        component="h2"
        sx={{
          fontFamily: "'Red Hat Display', sans-serif",
          fontWeight: 700,
          fontSize: { xs: "22px", sm: "28px", md: "36px" },
          lineHeight: 1.4,
          letterSpacing: "-0.36px",
          color: "#1D1D1B",
          textAlign: "center",
          textTransform: "capitalize",
          maxWidth,
          m: 0,
        }}
      >
        {title}
      </Box>
    )}
    {subtitle && (
      <Box
        component="p"
        sx={{
          fontFamily: "'Red Hat Display', sans-serif",
          fontWeight: 400,
          fontSize: { xs: "14px", md: "16px" },
          lineHeight: 1.5,
          color: "#686866",
          textAlign: "center",
          maxWidth,
          mt: "16px",
          mb: 0,
        }}
      >
        {subtitle}
      </Box>
    )}
  </Box>
);

export default SectionHeader;
